<template>
  <div class="flex md:flex-col-reverse">
    <button
      v-for="index in 2"
      :key="'utilityButton ' + index"
      class="cursor-pointer hover:bg-gray-400 rounded-full w-12 h-9 p-1"
      @click="utilityClicked(index === 1)"
    >
      <img
        class="w-full"
        :src="1 === index ? question : cc"
        :alt="1 === index ? 'question mark' : 'black dots'"
        loading="lazy"
      />
    </button>
  </div>
</template>

<script>
import question from "../../assets/announcement-24px.svg";
import cc from "../../assets/ccheart_black.svg";
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      question,
      /*  dots, */
      cc,
    };
  },
  mounted() {
    const firstView = localStorage.getItem("aboutOverlay");
    if (!firstView) {
      if (!this.getAbout) this.clickTimeout();
      else this.utilityClicked(true);
      localStorage.setItem("aboutOverlay", true);
    }
  },
  computed: {
    ...mapGetters(["getIsMobile", "getAbout", "getTermsOfUse"]),
  },
  methods: {
    ...mapMutations(["setOverlay"]),
    clickTimeout() {
      setTimeout(() => {
        if (!this.getAbout) this.clickTimeout();
        else this.utilityClicked(true);
      }, 2000);
    },
    utilityClicked(isQuestionClicked) {
      const obj = {
        active: true,
        title: isQuestionClicked ? "About" : "Terms of use",
        content: isQuestionClicked ? this.getAbout : this.getTermsOfUse,
      };
      this.setOverlay(obj);
    },
  },
};
</script>
